import { Component, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DialogResult } from '@progress/kendo-angular-dialog';
import { Observable } from 'rxjs';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { UserSelectDialogComponent } from 'src/app/feature-module/portal-users/components/user-select-dialog/user-select-dialog.component';
import { CustomDialogSettings } from 'src/app/shared/model/CustomDialogSettings';
import { CustomDialogService } from 'src/app/shared/services/custom-dialog.service';
import { EmployeeService } from '../../service/employee.service';
import { EmployeeSearchResultItem } from '../../models/EmployeeSearchResultItem';
import { SearchEmployeesCriteria } from '../../models/SearchEmployeesCriteria';
import { Constants } from 'src/app/shared/model/Constants';
import { EmployeeSelectDialogComponent } from '../employee-select-dialog/employee-select-dialog.component';
import { AssociatedEmployeeToEmployeeCompanyRequest } from '../../models/AssociatedEmployeeToEmployeeCompanyRequest';

@Component({
  selector: 'app-employee-company-associated-employees',
  templateUrl: './employee-company-associated-employees.component.html',
  styleUrls: ['./employee-company-associated-employees.component.scss']
})
export class EmployeeCompanyAssociatedEmployeesComponent implements OnInit {

  constructor(private employeeService: EmployeeService,
    private uiNotification : UiNotificationService,
    private customDialogService: CustomDialogService) { }

    associatedEmployees$: Observable<EmployeeSearchResultItem[]>;
  @Input() associatedEmployeeCompanyId: number


  @ViewChild("employeeSelectionForAssociationDialog", { read: ViewContainerRef })
  public containerRef: ViewContainerRef;
  
  ngOnInit(): void {
   this.loadData();
  }

  loadData() {
    
    const getAssociatedEmployeesCriteria :  SearchEmployeesCriteria =
    {
      text:'',
      withInspectionRoleAllowed: false,
      withTechnicianRoleAllowed: false,
      withAssemblyRoleAllowed: false,
      withEmployeeTechnicianAllowed: false,
      withEmployeeMeritoricAllowed: false,
      withPartsHandlingEmployeeAllowed: false,
      onlyInternalEmployee: false,
      associatedEmployeeCompanyId: this.associatedEmployeeCompanyId,
      pageNumber: 1,
      rowsPerPage: Constants.MaxInt,
    };

    this.associatedEmployees$ = this.employeeService.searchEmployees(getAssociatedEmployeesCriteria);
  }


  associateEmployee() {

    const dialogSettings: CustomDialogSettings = {
      content: EmployeeSelectDialogComponent,
      minHeight: '15vh',
      minWidth: '30vw',
      appendTo: this.containerRef,
      dialogInputs: {
      },
      resultCallback: (r: DialogResult) => {
        if (r['text'] == 'OK') {

          const selectedEmployeeId = r['selectedEmployeeId'];
          if(selectedEmployeeId){
 
            const req: AssociatedEmployeeToEmployeeCompanyRequest = {
              employeeId: selectedEmployeeId,
              employeeCompanyId: this.associatedEmployeeCompanyId
            };

             this.employeeService.associateEmployeeToEmployeeCompany(req).subscribe(
               () => {
                 this.uiNotification.showSuccess('validations.dataStoredSuccesfully');
                 this.loadData();
               });
          }
        }
      }
    };

    this.customDialogService.showDialog(dialogSettings);
  }


  removeEmployeeAssociation(employeeId: number){

      const req: AssociatedEmployeeToEmployeeCompanyRequest = {
        employeeId: employeeId,
        employeeCompanyId: null
      };

       this.employeeService.associateEmployeeToEmployeeCompany(req).subscribe(
         () => {
           this.uiNotification.showSuccess('validations.dataStoredSuccesfully');
           this.loadData();
         });
    }

}
